import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DashboardCardsService } from "@app-service/dashboard-cards.service";
import { UserService } from "@app-service/user.service";

@Component({
    selector: "app-meal-card-info",
    templateUrl: "./petty-cash-info.component.html",
    styleUrls: ["./petty-cash-info.component.scss"],
    standalone: false
})
export class PettyCashInfoComponent implements OnInit {
  constructor(
    private router: Router,
    public userService: UserService,
    private dashboardCardsService: DashboardCardsService
  ) {}

  ngOnInit(): void {}

  onSettingUp(): void {
    this.dashboardCardsService.changeActiveDisplayTab("cards");
    this.router.navigate([`/pettyCash/admin`], {
      queryParams: { program: "petty_cash" },
    });
  }
}
